/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// iui-utils
import {getCookie, parseQueryString} from '@insticator/insticator-ui'; // iui-utils
// redux utils
import {createSlice} from '@reduxjs/toolkit';
// thunks
import {
  fetchUserPermissions,
  updateSelectedSite,
} from '../thunks/session';
import {
  fetchAccountSitesAndApps
} from '../thunks/account';
import { updateProfileInfo } from '../thunks/users';


/* ========== ~~~~~~~~~~ SESSION SLICE : REDUCER ~~~~~~~~~~ ========== */
const initialState = {
  accountUUID: getCookie('account_uuid'), // READ COOKIE TO DETERMINE WHETHER USER IS SIGNED IN
  userUUID: getCookie('user_uuid'),
  isSignedIn: !!getCookie('account_uuid') && !!getCookie('user_uuid'),
  showSetPassword: !!getCookie('show_set_password'),
  showTermsAndConditions: getCookie('show_terms_and_condition') === 'true',
  agreementUUID: getCookie('agreement_uuid'),
  mocked: (getCookie('session_source') === 'ADMIN_PANEL_MOCK'),
  mockupGenerator: (getCookie('session_source') === 'MOCKUP_GENERATOR'),
  autoLoginPubPortalV2: getCookie('auto_login_pub_portal_v2') === 'true',
  siteUUID: getCookie('site_uuid'),
  selectingSite: false, 
  permissions: [],
  permissionsReceived: false,
  userEmail: null,
  userFirstName: null,
  userLastName: null,
  userPhoneNumber: null,
  language: null,
  languages: null,
  cookieEnabled: null,
  userAgent: null,
  pageurl: null,
  device: null,
  ip: null,
  lastActionDispatchedAt: new Date().getTime(),
  queryParams: parseQueryString(document.location.search),
  storedSessionData: null,
  updatingProfileInfo: false
};


export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setUserIP: (state, action) => {
      console.log("@@@ SETTING USER IP @@@@", action.payload)
      state.ip = action.payload
    },
    setSessionData: (state, action) => {
      console.log("@@@ SETTING SESSION STATUS @@@@", action.payload)
      state = {...state, ...action.payload}
    },
    storeSessionData: (state, action) => {
      state.storedSessionData = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUserPermissions.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchUserPermissions.fulfilled, (state, action) => {
        const {firstName, lastName, email, phoneNumber, permissions} = action.payload
        state.permissions = permissions
        state.permissionsReceived = true
        state.userEmail = email
        state.userFirstName = firstName
        state.userLastName = lastName
        state.userPhoneNumber = phoneNumber
      })
      // .addCase(fetchUserPermissions.rejected, (state, action) => {
      // })
      .addCase(fetchAccountSitesAndApps.fulfilled, (state, action) => {
        state.siteUUID = state.siteUUID || Object.keys(action.payload.sites || action.payload)[0]
      })
      .addCase(updateSelectedSite.pending, (state, action) => {
        state.selectingSite = true
      })
      .addCase(updateSelectedSite.fulfilled, (state, action) => {
        state.siteUUID = action.payload
        state.selectingSite = false
      })
      .addCase(updateProfileInfo.pending, (state, action) => {
        state.updatingProfileInfo = true
      })
      .addCase(updateProfileInfo.fulfilled, (state, action) => {
        const {firstName, lastName, email, phoneNumber } = action.payload
        state.userEmail = email
        state.userFirstName = firstName
        state.userLastName = lastName
        state.userPhoneNumber = phoneNumber
        state.updatingProfileInfo = false
      })
      .addCase(updateProfileInfo.rejected, (state, action) => {
        state.updateProfileInfo = false
      })
  }
});

export const {setUserIP, setSessionData, storeSessionData} = sessionSlice.actions;
export default sessionSlice.reducer;
